import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
type UpdateTicketDTO = {
    status: string,
};

type TicketResponse  = ApiError;

export const UpdateTicket = (data: UpdateTicketDTO, ticketId:string): Promise<TicketResponse> => {
    return axios.patch(`/support/changeTicketStatus/${ticketId}`, data)
        .then(response => response.data as TicketResponse);
};